import * as React from 'react';
import { useState, useCallback, memo }  from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { DetailRating } from '../DetailRating';
import { setColorByRating } from '../../../../utils/reviews';
import { getVerbalHotelReviews } from '../../../../utils/format';
import {
    ReviewsAmountByGrade,
    AdditionalRating,
    RatingGrade,
    RatingWordType
} from '../../../../models/hotel-reviews';
import AggregateRating  from 'sletat-ui-components2/dist/components/AggregateRating';
import classNames from 'classnames';

export interface HeaderProps {
    reviewAmount: number;
    rating: number;
    detailRating: AdditionalRating;
    detailRatingCount: AdditionalRating;
    reviewAmountByRating: ReviewsAmountByGrade;
    isMobile: boolean;
}

interface StyledHeaderProps extends JSSClassesProps<ComponentJSSClasses>, HeaderProps {}

const MAX_PERCENT = 100;
const ANIMATION_TIMING = 100;

const calcWidthByReviewAmount = (
    allReviewsAmount: number,
    reviewsAmountByGrade: number
): number => Math.round((MAX_PERCENT / allReviewsAmount) * reviewsAmountByGrade);

export const Header = memo(function(props: StyledHeaderProps) {
    const {
        classes,
        reviewAmount = 0,
        rating,
        detailRating,
        detailRatingCount,
        reviewAmountByRating,
        isMobile,
    } = props;
    const [showDetail, setShowDetail] = useState<boolean>(false);
    const [closeAnimation, setCloseAnimation] = useState<boolean>(false);

    const startCloseAnimationHandler = () => {
        setCloseAnimation(true);
        setTimeout(() => {
            setShowDetail(false);
            setCloseAnimation(false);
        }, ANIMATION_TIMING);
    };

    const handleShowDetail = () => setShowDetail(true);
    const handleHideDetail = () => startCloseAnimationHandler();

    const renderReviewAmountBar = useCallback((reviewAmount: number, grade: RatingWordType) => {
        const barStyle = {
            background: setColorByRating(RatingGrade[grade]),
            width: calcWidthByReviewAmount(
                reviewAmount,
                reviewAmountByRating[grade]
            ) + '%',
        };
        return (
          <div className={classes.reviewAmountDetails}>
            <div className={classes.reviewAmountHeadings}>
              <span>Положительные</span>
              <span>С критикой</span>
            </div>
            <div className={classes.reviewAmountBar}>
              <div style={barStyle} className={classes.bar} />
            </div>
            <div className={classes.reviewAmountInner}>
              <span className={classNames(classes.amount, classes.amountGood)}>
                  {reviewAmountByRating[grade]}
              </span>
              <span className={classes.amount}>
                {reviewAmount - reviewAmountByRating[grade]}
              </span>
            </div>
          </div>
        );
    }, [reviewAmount, reviewAmountByRating]);

    return (
        <header className={classes.container}>
            <div className={classes.ratingInner}>
                <div className={classes.reviewAmountWrapper}>
                    <AggregateRating rating={rating} size="large" />
                    <p className={classes.reviewAmount}>
                        {reviewAmount} {getVerbalHotelReviews(reviewAmount)}
                    </p>
                </div>
                {renderReviewAmountBar(reviewAmount, RatingWordType.Good)}
            </div>

            {isMobile && showDetail && (
                <button className={classes.detailButton} onClick={handleHideDetail}>
                    Скрыть детальную оценку
                </button>
            )}

            {isMobile && !showDetail && (
                <button className={classes.detailButton} onClick={handleShowDetail}>
                    Детальная оценка
                </button>
            )}
            {isMobile && showDetail && (
                <div
                    className={
                        `${classes.detailWrapper}
                         ${closeAnimation ? classes.detailWrapperCloseAnimation : ''}`}
                >
                    <DetailRating rating={detailRating} ratingCount={detailRatingCount} />
                </div>
            )}

            {!isMobile && <DetailRating rating={detailRating} ratingCount={detailRatingCount} />}
        </header>
    );
});

export default Header;
